<script setup lang="ts">
import type {
  ESprites,
  ESpritesCards,
  ESpritesFlags,
  ESpritesSocials,
  ESpritesUI
} from '@/shared/enum/sprites.enum'

const props = withDefaults(
  defineProps<{
    file: ESprites
    name: string | ESpritesCards | ESpritesFlags | ESpritesSocials | ESpritesUI
    width?: number | string
    height?: number | string
    title?: string
  }>(),
  {
    width: 20,
    height: 20
  }
)
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    role="img"
    :aria-hidden="props.title ? 'false' : 'true'"
    focusable="false"
    class="svg-icon"
  >
    <title v-if="props.title">{{ props.title }}</title>
    <use :xlink:href="`#${props.name}`" width="100%" height="100%" />
  </svg>
</template>

<style scoped>
.svg-icon {
  vertical-align: middle;
  fill: currentColor;
}
</style>
